/**
 * @desc 根据sku编码/FNSKU码，并获取产品装箱信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierProduct.getSkuInfo.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierProduct/getSkuInfo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
